import axios from 'axios';
import Api from '@/core/Api';

export default (report) => {
  Api.post(`/error_reporting`, { error: report });
};
